import fetch from "isomorphic-unfetch"
import { AddressesResponseSchema, type DataGouvAddressesResponse } from "./schema"

export async function fetchAddresses(query: string) {
    const response = await fetch(`https://data.geopf.fr/geocodage/search/?q=${query}`)
    const json = await response.json()

    return AddressesResponseSchema.parse(json)
}

export type { DataGouvAddressesResponse }
